<div class="main-box" id="account-menu-container">
  <div class="icon-container">
    <mat-select
      [hideSingleSelectionIndicator]="true"
      [(ngModel)]="currentLang"
      (click)="$event.stopPropagation()"
      [panelClass]="'language-select-panel'"
    >
      <mat-option [value]="language" *ngFor="let language of languages">
        {{ language | uppercase }}
      </mat-option>
    </mat-select>
    <button
      mat-mini-fab
      aria-label="icon-button with a person icon"
      color="primary"
      [disabled]="!sessionService.isLoggedIn"
      routerLink="/profile"
      routerLinkActive="active"
    >
      <mat-icon>person</mat-icon>
    </button>
    <button
      mat-icon-button
      aria-label="icon-button with a logout icon"
      matTooltip="{{ 'tooltip.logout' | translate }}"
      [disabled]="!sessionService.isLoggedIn"
      (click)="logout()"
      color="primary"
      id="account-menu-logout-button"
    >
      <mat-icon>logout</mat-icon>
    </button>
  </div>
  <div class="button-container" *ngIf="!sessionService.isLoggedIn">
    <button mat-stroked-button color="primary" id="login-button" routerLink="/login" routerLinkActive="active">
      {{ "button.login" | translate }}
    </button>
    <!-- <button mat-button routerLink="/registration-choice" routerLinkActive="active">
      {{ "button.register" | translate }}
    </button> -->
  </div>
  <div class="button-container" *ngIf="sessionService.isLoggedIn">
    <app-organization-switcher idPrefix="account-menu-orgId-"></app-organization-switcher>
  </div>
</div>
